import { DateTime } from 'luxon';
import { getBrowserTimezone } from './timezoneLocalStorage';

enum DateFormats {
  TIME = 'hh:mm a',
  FULL_DATE = 'MM/dd/yyyy',
  MONTH_DAY = 'LLL dd',
}

const getValidTimezone = (timeZone?: string): string => {
  if (!timeZone || !DateTime.local().setZone(timeZone).isValid) {
    return getBrowserTimezone() || 'UTC';
  }

  return timeZone;
};

const dateFormatter = (format: DateFormats, date?: string, timeZone?: string): string => {
  if (!date) {
    return '';
  }
  const ISOdate = DateTime.fromISO(date.trim());

  return ISOdate.setZone(getValidTimezone(timeZone)).toFormat(format);
};

const mailCreatedFormatter = (date: string, timeZone: string): string => {
  const ISOdate = DateTime.fromISO(date.trim());

  return ISOdate.setZone(getValidTimezone(timeZone)).toLocaleString(DateTime.DATETIME_FULL);
};

const mailViewDateFormatter = (date: string, timeZone: string): { time: string; date?: string } => {
  const validTimeZone = getValidTimezone(timeZone);
  const ISOdate = DateTime.fromISO(date.trim());
  const isCurrentYear = ISOdate.year === DateTime.local().year;
  const time = dateFormatter(DateFormats.TIME, date, validTimeZone);

  if (ISOdate.toISODate() === DateTime.local().toISODate()) {
    return { time };
  }

  if (isCurrentYear) {
    return {
      date: dateFormatter(DateFormats.MONTH_DAY, date, validTimeZone),
      time: time,
    };
  }

  return {
    date: dateFormatter(DateFormats.FULL_DATE, date, validTimeZone),
    time: time,
  };
};

const mailListDateFormatter = (date: string, timeZone: string): string => {
  const validTimeZone = getValidTimezone(timeZone);
  const ISOdate = DateTime.fromISO(date.trim());

  if (ISOdate.toISODate() === DateTime.local().toISODate()) {
    return dateFormatter(DateFormats.TIME, date, validTimeZone);
  }

  return ISOdate.setZone(validTimeZone).toFormat(DateFormats.FULL_DATE);
};

const contactDateFormatter = (date = ''): string => dateFormatter(DateFormats.FULL_DATE, date, 'utc');

export { mailCreatedFormatter, contactDateFormatter, mailViewDateFormatter, mailListDateFormatter };
